import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation } from "@/mixins/index";
import { needpaychannelgames, addneedpaychannelgame } from "@/api/management/rechargeChannelGameManagement";
import addrechargeChannelGame from "./components/addrechargeChannelGame";
import { listNo } from "@/api/advRelation";
export default {
  name: "rechargeChannelGameManagement",
  mixins: [serchSelect, tabulation],
  components: {
    addrechargeChannelGame: addrechargeChannelGame
  },
  data: function data() {
    return {
      total: 0,
      tableData: []
    };
  },
  created: function created() {},
  activated: function activated() {
    this.searchClick();
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.reqLoading = true;
      needpaychannelgames().then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    }
  }
};